<template>
  <div
    v-if="version === 'v1'"
    class="tw-w-full tw-bg-[var(--white)]"
    :class="isFocus ? 'tw-border tw-border-[#333]' : 'search-box-container'"
  >
    <div class="d-flex flex-row align-items-center">
      <span class="nc-icon-search ps-4" style="font-size: 20px"> </span>
      <input
        v-if="debounceHandler"
        v-model="keyword"
        class="form-input w-input n-input ps-3 tw-h-[50px] tw-w-full tw-outline-0"
        style="margin-bottom: 0 !important; border: unset !important"
        maxlength="256"
        :placeholder="placeholder"
        type="text"
        @keyup="debounceHandler()"
        @keyup.enter="debounceHandler()"
        @focus="onFocusStatusChanged(true)"
        @focusout="onFocusStatusChanged(false)"
      />
      <div v-if="keyword" class="pe-2">
        <svg
          class="n-cursor-pointer"
          style="font-size: 30px"
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          viewBox="0 0 36 36"
          @click="clearSearch()"
        >
          <path
            fill="currentColor"
            d="m19.41 18l8.29-8.29a1 1 0 0 0-1.41-1.41L18 16.59l-8.29-8.3a1 1 0 0 0-1.42 1.42l8.3 8.29l-8.3 8.29A1 1 0 1 0 9.7 27.7l8.3-8.29l8.29 8.29a1 1 0 0 0 1.41-1.41Z"
            class="clr-i-outline clr-i-outline-path-1"
          />
          <path fill="none" d="M0 0h36v36H0z" />
        </svg>
      </div>
    </div>
  </div>
  <div
    v-else-if="version === 'v2'"
    class="n-search-box tw-w-full tw-border-2 tw-bg-[var(--white)] tw-transition-all tw-duration-300"
    style="border-radius: var(--rounded-input) !important"
    :style="isFocus ? 'box-shadow: var(--c-box_shadow)' : ''"
  >
    <div class="tw-flex tw-w-[95%] tw-items-center tw-gap-4">
      <span class="nc-icon-search tw-ps-4 !tw-font-bold" style="font-size: 20px"> </span>
      <input
        v-if="debounceHandler"
        v-model="keyword"
        class="n-input tw-h-[50px] tw-w-full tw-placeholder-gray-300 tw-outline-0 active:tw-outline-0"
        style="margin-bottom: 0 !important; border: unset !important"
        maxlength="256"
        :placeholder="placeholder"
        type="text"
        @keyup="debounceHandler()"
        @keyup.enter="debounceHandler()"
        @focus="onFocusStatusChanged(true)"
        @focusout="onFocusStatusChanged(false)"
      />
      <div v-if="keyword" class="pe-2">
        <svg
          class="n-cursor-pointer"
          style="font-size: 30px"
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          viewBox="0 0 36 36"
          @click="clearSearch()"
        >
          <path
            fill="currentColor"
            d="m19.41 18l8.29-8.29a1 1 0 0 0-1.41-1.41L18 16.59l-8.29-8.3a1 1 0 0 0-1.42 1.42l8.3 8.29l-8.3 8.29A1 1 0 1 0 9.7 27.7l8.3-8.29l8.29 8.29a1 1 0 0 0 1.41-1.41Z"
            class="clr-i-outline clr-i-outline-path-1"
          />
          <path fill="none" d="M0 0h36v36H0z" />
        </svg>
      </div>
    </div>
  </div>
  <div
    v-else-if="version === 'v3'"
    class="n-search-box tw-w-full tw-transition-all tw-duration-300"
    style="border-radius: var(--rounded-input) !important"
    :style="isFocus ? 'box-shadow: var(--c-box_shadow)' : ''"
  >
    <div class="tw-flex tw-w-[95%] tw-items-center tw-gap-4">
      <span class="nc-icon-search tw-ps-4 !tw-font-bold" style="font-size: 20px"> </span>
      <input
        v-if="debounceHandler"
        v-model="keyword"
        class="n-input tw-h-[60px] tw-w-full tw-outline-0 active:tw-outline-0"
        style="margin-bottom: 0 !important; border: unset !important"
        maxlength="256"
        :placeholder="placeholder"
        type="text"
        @keyup="debounceHandler()"
        @keyup.enter="debounceHandler()"
        @focus="onFocusStatusChanged(true)"
        @focusout="onFocusStatusChanged(false)"
      />
      <div v-if="keyword" class="pe-2">
        <svg
          class="n-cursor-pointer"
          style="font-size: 30px"
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          viewBox="0 0 36 36"
          @click="clearSearch()"
        >
          <path
            fill="currentColor"
            d="m19.41 18l8.29-8.29a1 1 0 0 0-1.41-1.41L18 16.59l-8.29-8.3a1 1 0 0 0-1.42 1.42l8.3 8.29l-8.3 8.29A1 1 0 1 0 9.7 27.7l8.3-8.29l8.29 8.29a1 1 0 0 0 1.41-1.41Z"
            class="clr-i-outline clr-i-outline-path-1"
          />
          <path fill="none" d="M0 0h36v36H0z" />
        </svg>
      </div>
    </div>
  </div>

  <div
    v-else-if="version === 'v4'"
    class="tw-w-full"
    :class="isFocus ? 'tw-border tw-border-[#fff]' : 'search-box-container4'"
  >
    <div class="d-flex flex-row align-items-center">
      <span class="nc-icon-search ps-4" style="font-size: 20px"> </span>
      <input
        v-if="debounceHandler"
        v-model="keyword"
        class="form-input w-input n-input ps-3 tw-h-[50px] tw-w-full tw-outline-0"
        style="margin-bottom: 0 !important; border: unset !important"
        maxlength="256"
        :placeholder="placeholder"
        type="text"
        @keyup="debounceHandler()"
        @keyup.enter="debounceHandler()"
        @focus="onFocusStatusChanged(true)"
        @focusout="onFocusStatusChanged(false)"
      />
      <div v-if="keyword" class="pe-2">
        <svg
          class="n-cursor-pointer"
          style="font-size: 30px"
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          viewBox="0 0 36 36"
          @click="clearSearch()"
        >
          <path
            fill="currentColor"
            d="m19.41 18l8.29-8.29a1 1 0 0 0-1.41-1.41L18 16.59l-8.29-8.3a1 1 0 0 0-1.42 1.42l8.3 8.29l-8.3 8.29A1 1 0 1 0 9.7 27.7l8.3-8.29l8.29 8.29a1 1 0 0 0 1.41-1.41Z"
            class="clr-i-outline clr-i-outline-path-1"
          />
          <path fill="none" d="M0 0h36v36H0z" />
        </svg>
      </div>
    </div>
  </div>
  

  
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { debounce } from '~/units/core/providers/debounce.provider';
import { SubComponentMixin } from '~/mixins/subComponent.mixin';

export type SearchMethod = () => Promise<any>;

export default {
  name: 'SearchBox',

  mixins: [SubComponentMixin],

  props: {
    modelValue: {
      required: true,
      type: String,
    },

    searchMethod: {
      required: true,
      type: Function as PropType<SearchMethod>,
    },

    searchResultList: {
      required: true,
      type: Array<any>,
    },

    placeholder: {
      required: false,
      default: 'Search',
      type: String,
    },

    version: {
      required: false,
      default: 'v1',
      type: String,
    },
  },
  emits: ['update:modelValue'],

  data() {
    return {
      isSearchResultsVisible: false,
      isLoading: false,

      debounceHandler: null,

      isFocus: false,
    };
  },

  computed: {
    keyword: {
      get() {
        return this.modelValue;
      },
      set(value: string) {
        this.$emit('update:modelValue', value);
      },
    },
  },

  mounted() {
    this.initDebounceHandler();
  },

  methods: {
    onFocusStatusChanged(value: boolean) {
      this.isFocus = value;
    },

    async clearSearch() {
      this.keyword = '';
      await this.searchMethod();
    },

    async onSearched() {
      try {
        this.isLoading = true;
        await this.searchMethod();
        this.isSearchResultsVisible = true;
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },

    initDebounceHandler() {
      if (!this.debounceHandler) {
        this.debounceHandler = debounce(this.onSearched, 750);
      }
    },
  },
};
</script>

<style scoped>
.search-box-container {
  border: 1px solid var(--default-border-color);
}
.search-box-container4 {
  border: 1px solid #fff;
}
</style>
